import { hasCapability, type User } from "../base";

export const contractorOwners = {
  read: (user: User) => hasCapability(user, "contractorOwners.read"),
  update: (user: User) => hasCapability(user, "contractorOwners.update"),
};
